/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MarketSearchTemplateQuery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./MarketSearchTemplateQuery'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MarketSearchTemplateReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MarketSearchTemplateQuery);
  }
}(this, function(ApiClient, MarketSearchTemplateQuery) {
  'use strict';




  /**
   * The MarketSearchTemplateReport model module.
   * @module model/MarketSearchTemplateReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MarketSearchTemplateReport</code>.
   * @alias module:model/MarketSearchTemplateReport
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>MarketSearchTemplateReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MarketSearchTemplateReport} obj Optional instance to populate.
   * @return {module:model/MarketSearchTemplateReport} The populated <code>MarketSearchTemplateReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Queries')) {
        obj['Queries'] = ApiClient.convertToType(data['Queries'], [MarketSearchTemplateQuery]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('CreatedByID')) {
        obj['CreatedByID'] = ApiClient.convertToType(data['CreatedByID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/MarketSearchTemplateQuery>} Queries
   */
  exports.prototype['Queries'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} CreatedByID
   * @default 0
   */
  exports.prototype['CreatedByID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


